import React, { Component } from 'react'
import { connect } from 'react-redux';
import moment from 'moment';
import './../style.css';

import { get_travel } from './../actions/print.action'

const dateFormat = 'YYYY/MM/DD';

class TravelPrint extends Component {

    constructor( props ){
        super( props );

        this.state = {
            data: {
                destinations: [],
                hotels: [],
                personal_travel: false,
                hotel_required: false,
                travel_advance: false,
                visa_required: false
            }
        }

    }

    componentWillMount(){
        let travel_id = this.props.match.params.id;
        this.props.get_travel( travel_id );
    }

    componentWillReceiveProps( nextProps ){
        if( nextProps.print.length !== 0 ){
            this.setState({
                data: nextProps.print.OUTPUT.DATA[0]
            });

            setTimeout(()=> {
                window.print()},700)

        }
    }


    render() {

        const list_destinations = this.state.data.destinations.map((item, k) => <tr>
            <td colSpan="1">
                <table border="1" style={{borderTop: 'none'}} width="100%">
                    <tbody>
                        <tr>
                            <td width="50%" style={{padding: '5px'}}>{ item.departure_location }</td>
                            <td width="25%" style={{padding: '5px'}}>{ item.departure_date }</td>
                            <td width="25%" style={{padding: '5px'}}>{ item.departure_time }</td>
                        </tr>
                    </tbody>
                </table>
            </td>
            <td colSpan="1">
                <table border="1" style={{borderTop: 'none'}} width="100%">
                    <tbody>
                        <tr>
                            <td width="50%" style={{padding: '5px'}}>{ item.arrival_location }</td>
                            <td width="25%" style={{padding: '5px'}}>{ item.arrival_date }</td>
                            <td width="25%" style={{padding: '5px'}}>{ item.arrival_time }</td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </tr> );

        const list_hotels = this.state.data.hotels.map((item,key) =><tr>
                                <td width="50%" style={{padding: '5px'}}>{ item.hotel_location }</td>
                                <td width="25%" style={{padding: '5px'}}>{ item.hotel_check_in }</td>
                                <td width="25%" style={{padding: '5px'}}>{ item.hotel_check_out }</td>
                            </tr>);

        return (
            <div className="print_wrapper travel">

                <table width="100%">

                <thead>
                    <tr>
                        <th colSpan="3">
                            <span className="print_logo"></span>
                            <span className="jgroup_logo"></span>
                        </th>
                    </tr>
                </thead>

                <tbody>

                    <tr>
                        <td colSpan="3">

                            <table width="100%">
                                <tbody>
                                    <tr>
                                        <td style={{ borderBottom: 'solid 1px #999',fontSize: 30, textAlign: 'center', height: '65px', lineHeight: '65px' }}>
                                            BUSINESS TRAVEL REQUISITION FORM
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3" height="40px"></td>
                    </tr>

                    <tr>
                        <td colSpan="1" width="48%">
                            <table border="1" width="100%">
                                <tbody>
                                    <tr>
                                        <td width="20%" style={{padding: '5px'}}><b>Name:</b></td>
                                        <td width="80%" style={{padding: '5px'}}>{ this.state.data.full_name }</td>
                                    </tr>
                                    <tr>
                                        <td width="20%" style={{padding: '5px'}}><b>Designation:</b></td>
                                        <td width="80%" style={{padding: '5px'}}>{ this.state.data.designation }</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td colSpan="1" width="2%"></td>
                        <td colSpan="1" width="48%">
                            <table border="1" width="100%">
                                <tbody>
                                    <tr>
                                        <td width="20%" style={{padding: '5px'}}><b>Date:</b></td>
                                        <td width="80%" style={{padding: '5px'}}>{ moment( this.state.data.date ).format(dateFormat) }</td>
                                    </tr>
                                    <tr>
                                        <td width="20%" style={{padding: '5px'}}><b>Department:</b></td>
                                        <td width="80%" style={{padding: '5px'}}>{ this.state.data.department }</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3" style={{ fontSize: "18px", textAlign: 'left', height: '50px', paddingTop: '25px' }}>
                            TRIP DETAILS
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3">

                            <table width="100%" border="0">
                                <thead>
                                    <tr>
                                        <th style={{backgroundColor: '#1984c2',color:'white',padding: '5px',textAlign:'center'}} width="50%">Departure</th>
                                        <th style={{backgroundColor: '#1984c2',color:'white',padding: '5px',textAlign:'center'}} width="50%">Arrival</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colSpan="1">
                                            <table border="1" width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td width="50%" style={{padding: '5px'}}><b>Location (Country w/ Sector)</b></td>
                                                        <td width="25%" style={{padding: '5px'}}><b>Date</b></td>
                                                        <td width="25%" style={{padding: '5px'}}><b>Preferred Time</b></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                        <td colSpan="1">
                                            <table border="1" width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td width="50%" style={{padding: '5px'}}><b>Location (Country w/ Sector)</b></td>
                                                        <td width="25%" style={{padding: '5px'}}><b>Date</b></td>
                                                        <td width="25%" style={{padding: '5px'}}><b>Preferred Time</b></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>

                                    {/* Data */}

                                    { list_destinations }

                                </tbody>
                            </table>
                            
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3" height="20px"></td>
                    </tr>

                    <tr>
                        <td colSpan="2" style={{padding: '10px 0'}}>
                            Was personal travel combined with this business trip?  &nbsp;<b>{ ( JSON.parse( this.state.data.personal_travel ) ) ? 'YES' : 'NO' }</b>
                        </td>
                        <td colSpan="2" style={{padding: '10px 0'}}>
                            Personal travel dates. &nbsp;<b>{moment( this.state.data.personal_travel_start_date ).format(dateFormat)} - {moment( this.state.data.personal_travel_end_date ).format(dateFormat)}</b>
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3" style={{ fontSize: '18px', textAlign: 'left', height: '50px' }}>
                            PURPOSE OF VISIT
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3">
                            <p>{ (this.state.data.purpose_of_visit)? this.state.data.purpose_of_visit: 'None' }</p>
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3" style={{ fontSize: '18px', textAlign: 'left', height: '50px' }}>
                            TRAVEL ADVANCE
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3">
                            <p style={{fontSize: '16px'}}><b><em>A travel advance is issued on an exceptional basis only.</em></b></p>
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="2" style={{padding: '10px 0'}}>Travel Advance required? &nbsp;<b>{ ( JSON.parse( this.state.data.travel_advance ) ) ? 'YES' : 'NO' }</b></td>
                        <td colSpan="2" style={{padding: '10px 0'}}>If YES, please state amount. AED/ &nbsp;<b>{ this.state.data.travel_advance_amount }</b></td>
                    </tr>

                    <tr>
                        <td colSpan="3" style={{ fontSize: '18px', textAlign: 'left', height: '50px' }}>
                            VISA REQUIREMENT
                        </td>
                    </tr>


                    <tr>
                        <td colSpan="3" style={{padding: '10px 0'}}>Is Visa Required? &nbsp;<b>{ ( JSON.parse( this.state.data.visa_required ) ) ? 'YES' : 'NO' }</b></td>
                    </tr>

                    <tr>
                        <td colSpan="3" style={{padding: '10px 0 0 0'}}><b>If YES, please provide some details: </b></td>
                    </tr>

                    <tr>
                        <td colSpan="3" style={{padding: '10px 0'}}>
                            <p>{ (this.state.data.visa_details) ? this.state.data.visa_details: 'None'  }</p>
                        </td>
                    </tr>
                    
                    <tr>
                        <td colSpan="3" style={{ fontSize: '18px', textAlign: 'left', height: '50px' }}>
                            HOTEL BOOKING
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3" style={{padding: '10px 0'}}>Hotel Booking required? &nbsp;<b>{ ( JSON.parse( this.state.data.hotel_required ) ) ? 'YES' : 'NO' }</b></td>
                    </tr>

                    <tr>
                        <td colSpan="3" style={{padding: '10px 0'}}><b>Hotel Booking Details</b></td>
                    </tr>

                    <tr>
                        <td colSpan="3">
                            <table border="1" width="100%">
                                <tbody>

                                    <tr>
                                        <td width="50%" style={{padding: '5px'}}><b>Location (Country w/ Sector)</b></td>
                                        <td width="25%" style={{padding: '5px'}}><b>Check - In</b></td>
                                        <td width="25%" style={{padding: '5px'}}><b>Check – Out</b></td>
                                    </tr>

                                    { list_hotels }
                                    
                                </tbody>
                            </table>
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3" height="20px"></td>
                    </tr>

                    <tr>
                        <td colSpan="3" style={{ fontSize: '18px', textAlign: 'left', height: '50px' }}>
                            REMARKS:
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3">
                            <p>{ (this.state.data.remarks)? this.state.data.remarks: 'None' }</p>
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3" style={{ fontSize: '18px', textAlign: 'left', height: '50px' }}>
                            OTHERS:
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3">
                            <p>{ (this.state.data.others)? this.state.data.others: 'None' }</p>
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3" height="110px"></td>
                    </tr>

                    <tr>
                        <td colSpan="3" style={{ borderBottom: 'solid 1px #999',fontSize: 26, textAlign: 'center', height: '65px', lineHeight: '65px' }}>
                            Approvals & Authorization:
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3" height="30px"></td>
                    </tr>

                    <tr>
                        <td colSpan="2">
                            <table  width="100%">
                                <tbody>
                                    <tr>
                                        <td width="20%" style={{padding: '10px 0'}}><b>Applicant</b></td>
                                        <td width="80%" style={{padding: '10px 0'}}>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td width="20%" style={{padding: '10px 0'}}>Name:</td>
                                        <td width="80%" style={{padding: '10px 0'}}>{ this.state.data.full_name }</td>
                                    </tr>
                                    <tr>
                                        <td width="20%" style={{padding: '10px 0'}}>Signature:</td>
                                        <td width="80%" style={{padding: '10px 0'}}>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td width="20%" style={{padding: '10px 0'}}>&nbsp;</td>
                                        <td width="80%" style={{padding: '10px 0'}}>&nbsp;</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td colSpan="2">
                            <table  width="100%">
                                <tbody>
                                    <tr>
                                        <td width="20%" style={{padding: '10px 0'}}><b>Approved By</b></td>
                                        <td width="80%" style={{padding: '10px 0'}}>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td width="20%" style={{padding: '10px 0'}}>Name:</td>
                                        <td width="80%" style={{padding: '10px 0'}}>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td width="20%" style={{padding: '10px 0'}}>Signature:</td>
                                        <td width="80%" style={{padding: '10px 0'}}>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td width="20%" style={{padding: '10px 0'}}>Designation:</td>
                                        <td width="80%" style={{padding: '10px 0'}}>&nbsp;</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3" height="30px"></td>
                    </tr>

                    <tr>
                        <td colSpan="3">
                            <b>Date of Authorization:</b>
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3" height="30px"></td>
                    </tr>

                    <tr>
                        <td colSpan="3" style={{ textAlign: 'center', padding: '10px 0', borderTop:'solid 1px #999', borderBottom:'solid 1px #999'}}>
                            <b><em>Note: Please submit form to HR Dept. atleast 7 days before the trip date</em></b>
                        </td>
                    </tr>

                    
                </tbody>
                
                </table>


            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        print: state.print
    }
}

export default connect( mapStatetoProps, { get_travel } )( TravelPrint );



// WEBPACK FOOTER //
// ./src/pages/prints/travel/index.js